export var NewDashboardOptInStatusEnum;
(function (NewDashboardOptInStatusEnum) {
    NewDashboardOptInStatusEnum["OPTED_IN"] = "opted_in";
    NewDashboardOptInStatusEnum["DISMISSED"] = "dismissed";
    NewDashboardOptInStatusEnum["OPTED_OUT"] = "opted_out";
})(NewDashboardOptInStatusEnum || (NewDashboardOptInStatusEnum = {}));
